import "./namespace.js";
import "./utilities/browser.js";
import "./utilities/translation_observer.js";

window.Sparkle ??= {};
window.Sparkle.Embed ??= {};

Sparkle.Embed.Container = {
  prepare: function (container) {
    var container = jQuery(container).addClass("sparkle-page-content-wrapper")[0];

    // Remove any naked text content nodes (e.g. an nbsp; added by a CMS)
    if (container.children.length === 0) {
      container.innerHTML = "";
    }

    if (Sparkle.Embed.Utilities.isEdge()) {
      Sparkle.Embed.Utilities.TranslationObserver.observe(container);
    }

    return container;
  },
};
